// extracted by mini-css-extract-plugin
export default {"cardsSection":"education_cardsSection__G67f8","info":"education_info__9PDOg"};